import React from "react";
import { Layout, Button, Typography, Row, Col } from "antd";
import { Link } from "react-router-dom";
import MojafinLogo from "../svg/mojafin";
import KasakaLogo from "../svg/kasaka";

const NotFoundPage: React.FC = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Layout.Header
        style={{
          position: "fixed",
          zIndex: 1,
          width: "100%",
          backgroundColor: "#FFFFFF",
        }}
      >
        <Row justify="space-between" align="middle">
          <Col>
            <Link to="/">
              <KasakaLogo />
            </Link>
          </Col>
          <Col>
            <Button type="primary" size="large" style={{ marginRight: 20 }}>
              <Link to="/">Go Back</Link>
            </Button>
          </Col>
          <Col xs={{ span: 0 }} lg={{ span: 24 }}></Col>
        </Row>
      </Layout.Header>

      <Layout.Content
        style={{
          padding: "20px",
          minHeight: "calc(100vh - 64px - 64px)",
          backgroundColor: "#FFFFFF",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ maxWidth: 400, width: "100%" }}>
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <Typography.Title level={2}>Page Not Found</Typography.Title>
          </div>
          <div style={{ textAlign: "center", marginBottom: 24 }}>
            <Typography.Text style={{ fontSize: 14 }}>The page you are looking for does not exist</Typography.Text>
          </div>
          
        </div>
      </Layout.Content>

      <Layout.Footer
        style={{
          backgroundColor: "#FFFFFF",
          padding: "24px 50px",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography.Text
          style={{ fontSize: 14, color: "rgba(0, 0, 0, 0.45)", flex: 1 }}
        >
          © {new Date().getFullYear()}{" "}
          <a href="https://www.afrocentec.com/">Afrocentec</a>. All rights reserved.
        </Typography.Text>
        <Typography.Text
          style={{
            fontSize: 14,
            color: "rgba(0, 0, 0, 0.45)",
            display: "inline-flex",
            justifyContent: "flex-end",
          }}
        >
          <MojafinLogo />
        </Typography.Text>
      </Layout.Footer>
    </Layout>
  );
};

export default NotFoundPage;